import React from "react";
import { FiActivity } from "react-icons/fi";
import { formatKioskDfaStatus, getKioskDfaStatus } from "../hooks/kioskDashboard.helpers";

const STATUS_ACCENTS = {
  good_for_load: "bg-emerald-50 text-emerald-600",
  balanced: "bg-sky-50 text-[#0075AC]",
  elevated_stress: "bg-amber-50 text-amber-600",
};

const KioskDfaStatusCard = ({ alpha1, loading = false }) => {
  const status = getKioskDfaStatus(alpha1);
  const value = loading ? "…" : formatKioskDfaStatus(status);
  const accentClasses = STATUS_ACCENTS[status] || "bg-slate-50 text-slate-500";

  return (
    <article className="bg-white border border-slate-200/80 rounded-2xl p-5 shadow-sm min-h-[145px]">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 font-display">Estado DFA</p>
          <p className="mt-3 text-xl font-bold text-[#1D1F3F] tracking-tight">{value}</p>
        </div>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${accentClasses}`}>
          <FiActivity className="w-5 h-5" />
        </div>
      </div>
    </article>
  );
};

export default KioskDfaStatusCard;
